import React, { FC } from "react";
import { i18n } from "@/locales";
import styles from "./styles.module.less";

export type AppType = "integrate" | "selfBuilt";

export const APP_TYPE_CONFIG_MAP: Record<
  AppType,
  {
    text: string;
    style: React.CSSProperties;
  }
> = {
  integrate: {
    text: i18n.t("common.integrateApp"),
    style: {
      color: "#E49907",
      backgroundColor: "rgba(255, 205, 56, 0.2)",
    },
  },
  selfBuilt: {
    text: i18n.t("common.selfBuiltApp"),
    style: {
      color: "#396AFF",
      backgroundColor: "#EBF0FF",
    },
  },
};
export const AppTypeTag: FC<{
  type: AppType;
}> = ({ type }) => {
  const config = APP_TYPE_CONFIG_MAP[type];

  return (
    <span style={config.style} className={styles.appTypeTag}>
      {config.text}
    </span>
  );
};
